import "./styles.scss";

import CardCreateSignerForm from "components/card-send-create/card-create-signers/card-create-signer-form";
import CardCreateSubsectionHeader from "components/card-send-create/card-create-subsection-header";
import { BaIconPencil } from "components/ui/icons";
import { PropTypes } from "prop-types";
import React from "react";

const CardCreateSignerManual = ({ cardSend, onChange, onErrors, onFinish }) => {
  const onSuccess = (result) => {
    onChange(result);
    onFinish();
  };

  return (
    <div className="card-create-signer-manual-container">
      <CardCreateSubsectionHeader Icon={BaIconPencil} title="ENTER MANUALLY" onBack={onFinish} />
      <div className="card-create-signer-manual-contents">
        <h3 className="card-create-signer-manual-title">Manually enter people to invite as signers:</h3>
        <p className="card-create-signer-manual-subtitle">
          Signers entered here will be added to your signers list. Actual invitations to sign will be sent when the card is scheduled.
        </p>
        <CardCreateSignerForm cardSend={cardSend} onErrors={onErrors} onChange={onSuccess} />
      </div>
    </div>
  );
};

CardCreateSignerManual.propTypes = {
  cardSend: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onErrors: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
};

export default CardCreateSignerManual;
